import { EventEntity } from '../schema/EventEntity';

const assign = require('object-assign');

export function updateEventProperties<T extends EventEntity>(
    targetEvent: T,
    newEvent: any,
    forceOverrideAllProperties: boolean = false
) {
    // When there is existing event we don't want to assign the existing properties
    // with the `undefined` properties of `eventToAdd` hence we create a new object without `undefined`
    // properties and then assign those to existing event.
    // We also extract the key out before updating the properties as we don't want existing event Key to
    // be overriden
    const { Key: _, ...newEventWithoutKey } = newEvent;
    const eventToUpdatePropertiesFrom = forceOverrideAllProperties
        ? newEventWithoutKey
        : getEventWithoutUndefinedProperties(newEventWithoutKey);
    assign(targetEvent, eventToUpdatePropertiesFrom);
}

function getEventWithoutUndefinedProperties<T extends EventEntity>(event: T): T {
    return Object.keys(event).reduce<T>(
        (eventWithoutUndefinedProps, prop) => {
            if (event[prop] !== undefined) {
                eventWithoutUndefinedProps[prop] = event[prop];
            }

            return eventWithoutUndefinedProps;
        },
        {} as T
    );
}
